import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { ActionSheetController, ModalController, NavController, Platform } from '@ionic/angular/standalone';
import { CommonService } from 'src/app/services/common.service';
import { HomeService } from 'src/app/services/home.service';
import { AppStateService } from 'src/app/services/init/app-state.service';
import { MediaService } from 'src/app/services/media.service';
 
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { altTags, storageKeys } from 'src/app/app.constants';
import { ProfileService } from 'src/app/services/profile.service';
import { AnalyticsService } from 'src/app/services/core/analytics/analytics.service';
import { analyticsData } from 'src/app/analytics.constants';
import { CroppingComponent } from 'src/app/modals/cropping/cropping.component';
import { Router } from '@angular/router';
import { MembershipService } from 'src/app/services/membership.service';
import { InitializationService } from 'src/app/services/core/optimisation/initialization.service';
import { Observable, Subject, takeUntil } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CommonModule } from '@angular/common';
import { IonAvatar, IonIcon, IonImg } from '@ionic/angular/standalone';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DateTimeService } from 'src/app/services/core/date-time/date-time.service';
@Component({
  selector: 'app-membership-card',
  templateUrl: './membership-card.component.html',
  styleUrls: ['./membership-card.component.scss'],
  imports: [CommonModule , IonAvatar,IonImg,IonIcon,FormsModule, ReactiveFormsModule, TranslateModule]
})
export class MembershipCardComponent implements OnInit, OnChanges , OnDestroy{
  @Input('loginCard') loginCard: boolean;
  @Input('homeCard') homeCard: boolean;
  @Input('membCard') membCard: boolean;
  @Input('walletCard') walletCard: boolean;
  @Input('termsCard') termsCard: boolean;
  @Input('benefitCard') benefitCard: boolean;
  @Input('cardDetails') cardDetails: any;

  @Input('showUserImg') showUserImg: any;
  @Input('cardImage') cardImage: any;
  @Input('logo') logo: any;
  @Input('cardData') cardData: any;
  @Input('membershipNumber') membershipNumber: any;
  @Input('cardType') cardType: any;
  @Input('diffDays') diffDays: any;
  @Input('staticContent') staticContent: any;
  @Input('expiryProgress') expiryProgress: any;
  @Input('qrScanner') qrScanner: any;
  private trigger: Subject<any> = new Subject();
  private nextWebcam: Subject<any> = new Subject();
  sysImage = '';
  isImageLoaded: boolean = false;
  isAddOn: boolean;
  imageSelected: boolean;
  memberImage: any;
  brandName: any;
  showUserImgLocal: any;
  public isMembershipYetToStart: boolean = false;
  public membershipEndDate: string = null
  appInitData: any;
  altTags = altTags;
  private destroy$ = new Subject<void>();
  constructor(
    public appState: AppStateService,
    private homeService: HomeService,
    public commonService: CommonService,
    public mediaService: MediaService,
    public plateform: Platform,
    public domSanitizer: DomSanitizer,
    private translate: TranslateService,
    private navCtrl: NavController,
    private actionSheetCtrl: ActionSheetController,
    private profileService: ProfileService,
    private analyticsService: AnalyticsService,
    private croppingModal: ModalController,
    private router: Router,
    private memberService: MembershipService,
    private init: InitializationService,
    private datetime: DateTimeService
  ) {
  
      console.log("58634782364678234782347823647", this.showUserImg );
     
     if(this.init.imageBase64){
      console.log("this.init.imageBase64", this.init.imageBase64);
      // this.showUserImgLocal = this.init.imageBase64;
      this.showUserImg = this.init.imageBase64;
      }
    else if(localStorage.getItem(environment?.headers?.program_id + ":" + 'imageUrlbase64') && localStorage.getItem(environment?.headers?.program_id + ":" + 'imageUrlbase64') != "null"){
      // this.showUserImgLocal =    localStorage.getItem(environment?.headers?.program_id + ":" + 'imageUrlbase64');
      this.showUserImg = localStorage.getItem(environment?.headers?.program_id + ":" + 'imageUrlbase64');
      console.log("showUserImg from membership card", this.showUserImg);
    
    }
    else{
      console.log("last else");
      this.showUserImg = "";
    }
console.log("this.logo", this.logo);

    
   }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.membershipNumber) {
      if (this.cardData?.startFrom) {
         this.isMembershipYetToStart = this.datetime.isSameOrAfter(this.datetime.parseNoFormat(this.cardData?.startFrom), Date.now())
      }
      console.log(`Is ${this.membershipNumber} Membership Started? `, !this.isMembershipYetToStart);
      if (this.isMembershipYetToStart) {
        const endDateArr = this.cardData.validThruShow.split(" ")
        if (endDateArr?.length > 1) 
          this.membershipEndDate = endDateArr[1]
      }
    }
  }

  // ngOnInit() {
  //   const appData = this.appState.getAppData();
  //   if (appData && appData.homeDetails) {
  //     this.isAddOn = appData.homeDetails.cardDetails.isAddon;
  //   }
  //   if (appData && appData.appInitData) {
  //     this.appInitData = appData.appInitData;
  //   }
  //   this.translate.get('configJson.brandsName').subscribe(res => {
  //     this.brandName = {
  //       brandName: res
  //     }
  //   })
  //   console.log("this.router.url ::>", this.router.url);
  //   if (this.router.url == '/tabs/subscription') {
  //     let localMembershipNumber = JSON.parse(localStorage.getItem(environment?.headers?.program_id + ":" + storageKeys.membershipNumber));
  //     try {
  //       console.log("Card Type::>", this.cardType);
  //       if (localMembershipNumber) {
  //         this.membershipNumber = localMembershipNumber?.membershipNumber;
  //       }
  //     } catch(e: any) {
  //       console.log("Membership Number issue ::>", this.membershipNumber);
  //     }
  //     this.memberService.membershipChange.subscribe( rs => {
   
  //         this.membershipNumber = this.homeService.membershipNumber;
      
  //       console.log("membershipNumber ::>", this.membershipNumber);
  //     });
  //   }
  // }

  //refactoring code 
  ngOnInit() {
  const appData = this.appState.getAppData();

  this.isAddOn = appData?.homeDetails?.cardDetails?.isAddon || false;
  this.appInitData = appData?.appInitData || null;

   this.brandName = { brandName: this.translate.instant('configJson.brandsName') }; //subs-unsubs

  console.log("this.router.url ::>", this.router.url);

  if (this.router.url === '/tabs/subscription') {
    const localStorageKey = `${environment.headers.program_id}:${storageKeys.membershipNumber}`;
    try {
      const localMembershipNumber = JSON.parse(localStorage.getItem(localStorageKey));
      if (localMembershipNumber?.membershipNumber) {
        this.membershipNumber = localMembershipNumber.membershipNumber;
      }
    } catch (e) {
      console.log("Membership Number issue ::>", this.membershipNumber);
    }

    this.memberService.membershipChange
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.membershipNumber = this.homeService.membershipNumber;
        console.log("membershipNumber ::>", this.membershipNumber);
      });
  }
}

ngOnDestroy() {
  this.destroy$.next();
  this.destroy$.complete();
}

  navigateToActivation(val) {
  
      // Add on member alert
      if (this.isAddOn && val != "visitor") {
        this.translate
          .get("spouse_membership.spouseMembershipAlert", { action: val })
          .subscribe((res) => {
            this.commonService.presentAlert("", res);
          });
        return;
      }
      // END: Add on member alert

      // ENABLE-CODE
      if (val != "visitor") {
          this.homeService.renewHeading = val;
          // if (this.cardData?.subscriptionType == storageKeys?.nationalSubscription) {
          //     this.navCtrl.navigateForward("/v2-renew-subscription");
          // } else {  
              this.navCtrl.navigateForward("/renew-reactivate-membership");
          // }
      } else {
        this.commonService.cardWalletBackButtonSelect = "home";
        this.commonService.promocodeCatogory = "";
        // this.navCtrl.navigateForward('BuyAnotherMembership', { queryParams: { promocode: false, appliedPromocode: "", flowType: "visitor" } });
        if (!(this.appInitData.buyMembership.nationalSubscription && this.appInitData.buyMembership.hotelSpecific)) {
            if (this.appInitData.buyMembership.nationalSubscription) {
                this.navCtrl.navigateForward('buy-another-subscription', { queryParams: { promocode: false, appliedPromocode: "", flowType: "visitor" } });
            } else if (this.appInitData.buyMembership.hotelSpecific) {
                this.navCtrl.navigateForward('buy-another/hotel-specific-membership', { queryParams: { promocode: false, appliedPromocode: "", flowType: "visitor" } });
            }
        } else {
            this.navCtrl.navigateForward('/select-plan-buy-another', { queryParams: { promocode: false, appliedPromocode: "", flowType: "visitor" } });
        }
        // const modal = await this.modalCtrl.create({
        //   component: EnrollModalComponent,
        //   componentProps: { type: "buy", flow: "visitor" },
        // });
        // modal.present();
      }
      // END: ENABLE-CODE

  }

  goToMembershipFunc() {
    if (this.homeCard) {
      // this.navCtrl.navigateForward("/tabs/membership");
      this.navCtrl.navigateForward('/tabs/subscription');
    }
    if (this.membCard) {
      this.navCtrl.navigateForward("/tabs/membership/cardBenefits");
    }

  }

  public getSnapshot(): void {
    this.trigger.next(void 0);
  }
  // public captureImg(webcamImage: WebcamImage): void {
  //   this.webcamImage = webcamImage;
  //   this.sysImage = webcamImage!.imageAsDataUrl;
  //   console.info('got webcam image', this.sysImage);
  // }
  public get invokeObservable(): Observable<any> {
    return this.trigger.asObservable();
  }
  public get nextWebcamObservable(): Observable<any> {
    return this.nextWebcam.asObservable();
  }
  
  async ChangeProfilePic(fileInput:HTMLInputElement) {
    console.log("changeprofile pic called");
    const pictureSourceSelector = await this.actionSheetCtrl.create({
      mode: "md",
      header: "Upload Photo",
      buttons: [
        {
          icon: "",
          text: "Upload from library",
          cssClass: "uploadButtonCommon gallery",
          handler: () => {
            fileInput.click()
            // this.mediaService
            //   .galleryfnc()
            //   .then((res) => {
            //     console.log("GalleryFuncSucc ==>", res);
            //     this.createImageURI(res, "upload");
            //   })
            //   .catch((err) => {
            //     console.log("GalleryFuncErr ==>", err);
            //   });
          },
        },
        {
          icon: "",
          text: "Take a picture",
          cssClass: "uploadButtonCommon camera",
          handler: () => {
            this.mediaService
              .camerafnc()
              .then((res) => {
                console.log("res from camera function");
                this.createImageURI(res, "take");
              })
              .catch((err) => {
              });
          },
        },
      ],
      cssClass: "uploadPicActionSht",
    });
    await pictureSourceSelector.present();
  }

  onFileChange(event: any) {
    console.log("onFileChange", event);
    const file = event.target.files[0];
    const reader = new FileReader();
  
    reader.onloadend = () => {
      const base64String = reader.result;
      console.log("base64String", base64String);
      this.createImageURI(base64String);
     
    };
  
   var dataurl=  reader.readAsDataURL(file);
   
  }

  async createImageURI(capturedImage: any, action?: any) {
    console.log("dataurl", capturedImage)
    console.log("createImageURI ==> ", capturedImage);
    const croppingModal = await this.croppingModal.create({ 
      component: CroppingComponent, 
      componentProps: {
        dataUrl:  capturedImage
      },
      backdropDismiss: false, 
      showBackdrop: false 
    });
    croppingModal.present();
    croppingModal.onDidDismiss().then((picData: any) => {
      if (picData.data.data) {
        console.log("app init data ==>>",this.appInitData)
        this.mediaService.resizeImage(picData.data.data).then(resizeImg => {
          console.log("resize image -->>",resizeImg)
          this.memberImage = resizeImg;
          this.showUserImg = this.memberImage;
          this.isImageLoaded = true;
          this.fetchClickImg(resizeImg);
        })
      }
    });
  }

  fetchClickImg(dataUrl: any) {
    fetch(dataUrl)
      .then(res => res.blob())
      .then(blob => {
        const appData = this.appState.getAppData();
        if (appData && appData.userDetails) {
          if (appData.userDetails.memberid) {
            this.uploadFile(dataUrl);
          }
        }
      });
  }

  uploadFile(imageURI) {
    if (navigator.onLine) {
      this.mediaService
        .upload(imageURI)
        .subscribe((res) => {
          if (res["statusCode"] == 200) {
            this.appState.saveUserImage({
                userImage: res['imageUrl']
            });
            localStorage.removeItem(environment?.headers?.program_id + ":" + "ImageUrl" );
            localStorage.removeItem(environment?.headers?.program_id + ":" + "imageUrlbase64" );
            this.init.imageBase64 = "";
            console.log(" this.initService.imageBase64",  this.init.imageBase64);
              localStorage.setItem(environment?.headers?.program_id + ":" + "ImageUrl",res['imageUrl'] );
              localStorage.setItem(environment?.headers?.program_id + ":" + "imageUrlbase64",imageURI );
              this.init.imageBase64 = imageURI;   
            console.log("this.showUserImgLocal", this.showUserImgLocal);
            // console.log("this.showUserImgLocal", localStorage.setItem(environment?.headers?.program_id + ":" + "ImageUrl",res['imageUrl'] ));
            this.homeService.getHomeCRMDetails();
            this.loadProfileData();
             this.commonService.presentToast(this.translate.instant("toastMsg.imageUploadSucc")); //subs-unsubs
          } else {
             this.commonService.presentToast( this.translate.instant("toastMsg.imgUploadFail")); //subs-unsubs
          }
        })
        // .catch((err) => {
        //   this.translate.get("toastMsg.imgUploadFail").subscribe((res) => {
        //     this.commonService.presentToast(res);
        //   });
        // });
    }
  }

  loadProfileData() {
    if (navigator.onLine) {
      this.profileService.getProfileDetails().then((res) => {
        if (res) {
          this.appState.saveProfileDetails(res);
        }
      });
    }
  }

  // Renew / Reactivate Membership Functionality
  goToTerms(event) {
      let memeberidEncrpit = this.appState.getEncryptedMemberId();
      this.analyticsService.trackAction(event.currentTarget.innerText, analyticsData.cardBenefitsAction, analyticsData.cardBenefitsClick, memeberidEncrpit);
      const appData = this.appState.getAppData();
      if (appData && appData?.aemData) {
          if (appData?.aemData?.membership?.membershipTermsConditionsUrl) {
              this.commonService.openInAppBrowser(appData?.aemData?.membership?.membershipTermsConditionsUrl,'_blank');
          } else {
              this.navCtrl.navigateForward(['/membership-card-terms']);
          }
      } else {
          this.navCtrl.navigateForward(['/membership-card-terms']);
      }
  }

  imageloading(){
    this.isImageLoaded = true;
  }

}

